
export const waitAMoment = async (milliseconds = 100) => {
    return new Promise<void>(resolve => {
        setTimeout(() => {
            resolve()
        }, milliseconds)
    })
}
